import { Button } from "@/components/ui/button";
import type { FactEditorStatus } from "@/hooks/use-fact-editor";

/** A save's state in plain words; a conflict also reads "Not saved" while its notice decides. */
function saveStatusLabel(status: FactEditorStatus<unknown> | null): string {
  if (!status) return "";
  if (status.kind === "saving") return "Saving";
  if (status.kind === "saved") return "Saved";
  return "Not saved";
}

/**
 * Where an in-place editor's save shows: "Saving", "Saved", or "Not saved"
 * with Retry when trying again can help. It is empty until something happens.
 */
export function SaveStatus({ status, onRetry }: { status: FactEditorStatus<unknown> | null; onRetry: () => void }) {
  return (
    <span className="flex items-center gap-1.5 text-meta text-muted-foreground">
      <span role="status">{saveStatusLabel(status)}</span>
      {status?.kind === "failed" && status.retry && (
        <Button type="button" variant="link" size="sm" className="px-0" onClick={onRetry}>
          Retry
        </Button>
      )}
    </span>
  );
}
